import { render, staticRenderFns } from "./day-configurator-add-item-modal.vue?vue&type=template&id=1a38294b&scoped=true&"
import script from "./day-configurator-add-item-modal.vue?vue&type=script&lang=js&"
export * from "./day-configurator-add-item-modal.vue?vue&type=script&lang=js&"
import style0 from "./day-configurator-add-item-modal.vue?vue&type=style&index=0&id=1a38294b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a38294b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a38294b')) {
      api.createRecord('1a38294b', component.options)
    } else {
      api.reload('1a38294b', component.options)
    }
    module.hot.accept("./day-configurator-add-item-modal.vue?vue&type=template&id=1a38294b&scoped=true&", function () {
      api.rerender('1a38294b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/day-configurator/modals/day-configurator-add-item-modal.vue"
export default component.exports